import styled from 'styled-components'

export const Wrapper = styled.div`
   width: 100%;
   color: #000;
   text-align: center;
`

export const Title = styled.h2`
   margin-bottom: 60px;
   font-size: 2rem;
   font-weight: 500;
   position: relative;
   color: #fff;
`